import { assign } from 'lodash';
import { getters as baseGetters, GETTER_TYPES as BASE_GETTER_TYPES } from '../base-collection/getters';

const GETTER_TYPES = assign({}, BASE_GETTER_TYPES, {});

const getters = assign({}, baseGetters, {});

export {
  getters,
  GETTER_TYPES,
};
